import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { FormikTouched } from 'formik/dist/types';

type Props = {
    label: string;
    name: string;
    data?: any[];
    size?: 'small' | 'medium';
    margin?: 'dense' | 'normal' | 'none';
    required?: boolean;
    value?: any[];
    touched?: boolean | FormikTouched<any> | FormikTouched<any>[];
    errors?: string | string[];
    disabled?: boolean;
    onChangeValue: (value: any[]) => void;
    reasonEnabled?: boolean;
    onReason?: (reason: string) => void;
    helperText?: string;
};

const MultipleAutocompleteField = ({
    label,
    name,
    data = [],
    size,
    margin,
    required,
    value = [],
    touched,
    errors,
    disabled,
    onChangeValue,
    reasonEnabled,
    onReason,
    helperText,
}: Props) => {
    return (
        <Autocomplete
            multiple
            id="tags-outlined"
            options={data}
            disabled={disabled}
            value={value}
            onChange={(_, newValue) => {
                onChangeValue(newValue || []);
            }}
            onInputChange={(_, __, reason) => {
                if (reasonEnabled && onReason) {
                    onReason(reason);
                }
            }}
            getOptionLabel={(option) => option.name || ''}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            filterSelectedOptions
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    name={name}
                    size={size}
                    margin={margin}
                    required={required}
                    helperText={touched ? errors || helperText : helperText}
                    error={touched && Boolean(errors)}
                    sx={{
                        '& label.Mui-focused': {
                            color: 'primary.main',
                        },
                        '& .MuiInput-underline:after': {
                            borderBottomColor: 'primary.main',
                        },
                        '& .MuiFilledInput-underline:after': {
                            borderBottomColor: 'primary.main',
                        },
                        '& .MuiOutlinedInput-root': {
                            '&.Mui-focused fieldset': {
                                borderColor: 'primary.main',
                            },
                        },
                    }}
                />
            )}
        />
    );
};

export default MultipleAutocompleteField;
